module.exports = __webpack_public_path__ + "img/crown.95cf37a7.png";